// src/Login.js
import React, { useState } from "react";
import { signInWithEmailAndPassword } from "firebase/auth";
import { auth } from "./firebase";

const Login = ({ onLogin, onGuest }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");

    try {
      const userCredential = await signInWithEmailAndPassword(auth, email, password);
      onLogin(userCredential.user);
    } catch (err) {
      setError("Fehler beim Login: " + err.message);
    }
  };

  return (
    <div className="flex flex-col items-center p-6">
      {/* Logo */}
      <img src="/logo_redkorps.jpg" alt="Logo" className="mb-4 w-60" />

      <h2 className="text-4xl font-bold text-center text-gray-800 mb-6">Login</h2>
      <h2 className="text-2xl font-bold text-center text-red-300 mb-3">Beispiel: "Kunibert Müller"</h2>
      <h2 className="text-l font-bold text-center text-yellow-400 mb-0">E-Mail: "k.mueller@redkorps.de"</h2>
      <h2 className="text-l font-bold text-center text-yellow-400 mb-3">Passwort: "mueller"</h2>      
      <h2 className="text-md text-center text-yellow-400 mb-3">ABER: Wenn der Nachname weniger als 6 Buchstaben hat, dann der "vorname" !</h2>
      <h2 className="text-md text-center text-yellow-400 mb-3">Außerdem: Wenn Dein Nachname "Kühn" ist, ist dein Passwort: "kkuehn" oder "pkuehn"</h2>
      {error && <p style={{ color: "red" }}>{error}</p>}
      <form onSubmit={handleLogin}>
        <input
          type="email"
          placeholder="E-Mail"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required 
          className="p-2 border border-gray-300 rounded-md mb-2 w-full"
        />
        <input
          type="password"
          placeholder="Passwort"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
          className="p-2 border border-gray-300 rounded-md mb-4 w-full"
        />
        <button type="submit" className="p-2 bg-red-800 text-white rounded-md hover:bg-red-900 focus:outline-none w-full">
          Login
        </button>
      </form>
      <button onClick={onGuest} className="p-1 bg-red-600 text-white rounded-md w-[200px] hover:bg-red-700" style={{ marginTop: "15px" }}>Weiter als Gast</button>
    </div>
  );
};

export default Login;
